import apiService from './api';

const careReferralCatalogService = {
  getCategories() {
    return apiService.get('/care-referral-catalog/categories');
  },

  list(params = {}) {
    return apiService.get('/care-referral-catalog', { params });
  },

  getById(id) {
    return apiService.get(`/care-referral-catalog/${id}`);
  },

  create(payload) {
    return apiService.post('/care-referral-catalog', payload);
  },

  update(id, payload) {
    return apiService.put(`/care-referral-catalog/${id}`, payload);
  },

  remove(id) {
    return apiService.delete(`/care-referral-catalog/${id}`);
  }
};

export default careReferralCatalogService;
